import { useQuery, ApolloError } from "@apollo/client";
import { FETCH_HEAD_TO_HEAD } from "../../queries";
import { HeadToHeadBattle, HeadToHeadData } from "../../types";

interface UseHeadToHeadHook {
  headToHeadLoading: boolean;
  headToHeadError?: ApolloError;
  headToHeadData?: HeadToHeadBattle;
  battleStatus?: string;
}

const useHeadToHead = (): UseHeadToHeadHook => {
  const {
    loading: headToHeadLoading,
    error: headToHeadError,
    data: headToHead
  } = useQuery<HeadToHeadData>(FETCH_HEAD_TO_HEAD, {
    variables: {},
    fetchPolicy: "network-only"
  });

  const getBattleStatus = (headToHead: HeadToHeadData | undefined) => {
    const battleTypes: (keyof HeadToHeadData)[] = ["currentHeadToHeadBattle", "nextHeadToHeadBattle", "recentlyFinishedHeadToHeadBattle"];
    for (const battleType of battleTypes) {
      const battleData = headToHead?.[battleType];
      if (battleData && Object.keys(battleData).length > 0) {
        return { battleStatus: battleType, headToHeadData: battleData };
      }
    }
    return { battleStatus: "No battles are active", headToHeadData: undefined };
  };
  const { battleStatus, headToHeadData } = getBattleStatus(headToHead) || {};
  return { headToHeadLoading, headToHeadError, headToHeadData, battleStatus };
};

export default useHeadToHead;
